import { PHONE, ADDRESS, WHATSAPP_URL, LOGO_URL } from "../data/site";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-foreground text-primary-foreground">
      <div className="max-w-[1600px] mx-auto px-4 md:px-8 py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 border-b border-white/15 pb-16">
          <div className="md:col-span-6">
            <a href="#top" className="inline-block bg-white rounded-sm p-4 md:p-5">
              <img
                src={LOGO_URL}
                alt="SleepVista"
                className="h-16 md:h-20 w-auto object-contain"
              />
            </a>
            <p className="text-primary-foreground/60 mt-6 max-w-sm text-base leading-relaxed">
              Premium foam & mattress manufacturing, crafted in Rohini, Delhi.
              The art of deep sleep.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="overline mb-5" style={{ color: "#7BA7CC" }}>Explore</p>
            <ul className="space-y-3 text-primary-foreground/70">
              <li><a href="#collection" className="hover:text-primary-foreground transition-colors">Collection</a></li>
              <li><a href="#story" className="hover:text-primary-foreground transition-colors">Our Story</a></li>
              <li><a href="#craft" className="hover:text-primary-foreground transition-colors">Materials</a></li>
              <li><a href="#contact" className="hover:text-primary-foreground transition-colors">Enquire</a></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="overline mb-5" style={{ color: "#7BA7CC" }}>Reach us</p>
            <a href={`tel:${PHONE}`} className="block text-primary-foreground/80 hover:text-primary-foreground transition-colors mb-3">{PHONE}</a>
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="block text-primary-foreground/80 hover:text-primary-foreground transition-colors mb-4">WhatsApp</a>
            <p className="text-primary-foreground/50 text-sm leading-relaxed">{ADDRESS}</p>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between gap-4 pt-8 text-xs text-primary-foreground/40 tracking-wide">
          <span>© {new Date().getFullYear()} SleepVista. All rights reserved.</span>
          <span>Manufactured with care in Delhi, India.</span>
        </div>
      </div>
    </footer>
  );
};
